module.exports = __webpack_public_path__ + "static/media/pullman01.91e2657a.jpg";